var _excluded = ["children", "className", "disabled", "hasError", "hasWarning", "hasSuccess", "id", "text", "type", "name", "value", "defaultChecked", "checked", "showInput", "variant", "onChange", "textHint", "withIcon", "hasBorder", "onContainerSize", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import ContainerQuery from './../container-query';
import generateID from './../../utilities/generateID';
import Divider from '../divider';
import InverseContext from '../../utilities/inverse-context';
import StyledSelectablePanel from './selectable-panel.styles';
import StyledSelectablePanelInput from './styles/selectable-panel.input.styles';
import StyledSelectablePanelControlIcon from './styles/selectable-panel.control-icon.styles';
import StyledSelectablePanelBd from './styles/selectable-panel.bd.styles';
import StyledSelectablePanelIcon from './styles/selectable-panel.icon.styles';
import StyledSelectablePanelText from './styles/selectable-panel.text.styles';
import StyledSelectablePanelTextHint from './styles/selectable-panel.text-hint.styles';
import StyledSelectablePanelChildren from './styles/selectable-panel.children.styles';
import StyledSelectablePanelDivider from './styles/selectable-panel.divider.styles';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var selectablePanelPropTypes = {
  /** Specifies main text for label */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Specifies additional information for the label */
  textHint: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Specify type=radio or type=checkbox. Default is type=checkbox. */
  type: PropTypes.oneOf(['checkbox', 'radio']),
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** You can specify a name for a group of radio buttons. */
  name: PropTypes.string,
  /** a default value */
  value: PropTypes.string,
  /** The default checked state. Use when the component is not controlled. */
  defaultChecked: PropTypes.bool,
  /** Determines whether or not the SelectablePanel is checked by default or not */
  checked: PropTypes.bool,
  /** Can insert children components. */
  children: PropTypes.node,
  /** Assign a custom id to the input. An id will be generated if no id is supplied. */
  id: PropTypes.string,
  /** onChange event handler */
  onChange: PropTypes.func,
  /** Adds disabled functionality/styling to the input. */
  disabled: PropTypes.bool,
  /** Chooses which style to use for selectable panel. 'solid' or 'outline' */
  variant: PropTypes.oneOf(['solid', 'outline']),
  /** Shows/hides checkbox or radio */
  showInput: PropTypes.bool,
  /** Adds an icon object or string to the panel, see Icon page for information on adding custom icons. Icon size is set */
  withIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Toggle the error state */
  hasError: PropTypes.bool,
  /** Toggle the warning state */
  hasWarning: PropTypes.bool,
  /** Toggle the success state */
  hasSuccess: PropTypes.bool,
  /** Toggle the bottom border state */
  hasBorder: PropTypes.bool,
  /**
   * @deprecated since 2.55.0
   * @see hasBorder
   */
  isBordered: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object,
  /** Callback for when component resizes */
  onContainerSize: PropTypes.func
};
var selectablePanelDefaultProps = {
  id: '',
  text: '',
  textHint: '',
  type: 'checkbox',
  className: '',
  name: '',
  value: '',
  defaultChecked: undefined,
  checked: undefined,
  disabled: false,
  onChange: function onChange() {},
  children: '',
  variant: 'solid',
  showInput: false,
  withIcon: '',
  hasError: false,
  hasWarning: false,
  hasSuccess: false,
  hasBorder: false,
  isBordered: null,
  utils: {},
  onContainerSize: function onContainerSize() {}
};
var useControlled = function useControlled(_ref) {
  var checked = _ref.checked,
    defaultChecked = _ref.defaultChecked;
  // if `checked` prop is passed, component is controlled. (this should never change)
  var _useRef = useRef(checked !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(checked !== undefined ? checked : Boolean(defaultChecked)),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  useEffect(function () {
    if (isControlled) {
      setIsChecked(checked);
    }
  }, [checked]);
  return {
    isCheckedProp: isControlled ? isChecked : undefined,
    isChecked: isChecked,
    setIsChecked: setIsChecked,
    isControlled: isControlled
  };
};

/**
 * @ignore @description
 * ## SelectablePanel Component
 * The SelectablePanel is a custom checkbox implementation that accepts the same properties as does a native checkbox and/or radio control
 *
 * @ignore @see Mesh: [SelectablePanel Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-selectablepanel--default)
 *
 * @ignore @example
 * ```jsx
 * import { SelectablePanel } from 'mesh-component-library';
 *
 * <SelectablePanel {...props} />
 * ```
 */
export var SelectablePanel = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    hasError = props.hasError,
    hasWarning = props.hasWarning,
    hasSuccess = props.hasSuccess,
    id = props.id,
    text = props.text,
    type = props.type,
    name = props.name,
    value = props.value,
    defaultChecked = props.defaultChecked,
    checked = props.checked,
    showInput = props.showInput,
    variant = props.variant,
    _onChange = props.onChange,
    textHint = props.textHint,
    withIcon = props.withIcon,
    hasBorder = props.hasBorder,
    onContainerSize = props.onContainerSize,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      checked: checked,
      defaultChecked: defaultChecked
    }),
    isChecked = _useControlled.isChecked,
    isCheckedProp = _useControlled.isCheckedProp,
    setIsChecked = _useControlled.setIsChecked,
    isControlled = _useControlled.isControlled;
  var uid = id || generateID('form_option_');
  return /*#__PURE__*/React.createElement(ContainerQuery, {
    onContainerSize: onContainerSize
  }, /*#__PURE__*/React.createElement(StyledSelectablePanel, {
    className: className,
    disabled: disabled,
    hasError: hasError,
    hasSuccess: hasSuccess,
    hasWarning: hasWarning,
    htmlFor: uid,
    showIconVariant: withIcon,
    showInputVariant: showInput,
    utils: utils,
    variant: variant
  }, /*#__PURE__*/React.createElement(StyledSelectablePanelInput, _extends({
    checked: isCheckedProp,
    className: "notranslate",
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: uid,
    name: name,
    onChange: function onChange(e) {
      // toggle `isChecked` state for uncontrolled only
      if (!isControlled) {
        setIsChecked(e.target.checked);
      }
      _onChange(e);
    },
    value: value,
    type: type,
    ref: forwardedRef,
    variant: variant
  }, other)), showInput && /*#__PURE__*/React.createElement(StyledSelectablePanelControlIcon, {
    type: type
  }, type == 'checkbox' && /*#__PURE__*/React.createElement(Icon, {
    icon: "check-solid",
    size: 1,
    alt: "Checkmark"
  })), /*#__PURE__*/React.createElement(StyledSelectablePanelBd, {
    variant: variant,
    hasBorder: hasBorder
  }, /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: isChecked && variant != 'solid'
  }, withIcon && /*#__PURE__*/React.createElement(StyledSelectablePanelIcon, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: withIcon,
    size: 2
  })), /*#__PURE__*/React.createElement(StyledSelectablePanelText, null, text, textHint && /*#__PURE__*/React.createElement(StyledSelectablePanelTextHint, {
    disabled: disabled,
    isInverse: isChecked && variant != 'solid'
  }, textHint)), children && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledSelectablePanelDivider, null, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(StyledSelectablePanelChildren, null, children))))));
});
SelectablePanel.propTypes = selectablePanelPropTypes;
SelectablePanel.defaultProps = selectablePanelDefaultProps;
SelectablePanel.displayName = 'SelectablePanel';

/**
 * @type React.FC<selectablePanelPropTypes>
 */
export default withDeprecatedProps(SelectablePanel);